define.alias("shared/modifiers/css-properties", "settings/modifiers/css-properties");